/**
 * Contact subject options mapping GraphQL enum values to German labels.
 * Used for categorizing contact-relevant comments.
 */
export const CONTACT_SUBJECTS: Array<{ value: string; label: string }> = [
  { value: 'PREMIUM_VERTRAG', label: 'Premium Vertrag' },
  { value: 'PREMIUM_AKQUISE', label: 'Premium Akquise' },
  { value: 'PREMIUM_AKQUISE_TERMIN', label: 'Premium Akquise Termin' },
  { value: 'PREMIUM_NACHFASSEN', label: 'Premium nachfassen' },
  { value: 'PREMIUM_AKQUISE_ABSAGE', label: 'Premium Akquise Absage' },
  { value: 'PREMIUM_KUENDIGUNG', label: 'Premium Kündigung' },
  { value: 'KATALOGABMELDUNG', label: 'Katalogabmeldung' },
  { value: 'SONSTIGES', label: 'Sonstiges' },
  { value: 'FEEDBACK', label: 'Feedback' },
  { value: 'BESCHWERDE_KUNDE', label: 'Beschwerde Kunde' },
  { value: 'BESCHWERDE_HOTEL', label: 'Beschwerde Hotel' },
  { value: 'BLACKLIST', label: 'Blacklist' },
  { value: 'AKQUISE', label: 'Akquise' },
  { value: 'PREISLISTE', label: 'Preisliste' },
  { value: 'PT_IM_HOTEL', label: 'pT im Hotel' },
  { value: 'PT_IM_OFFICE', label: 'pT im Office' },
  { value: 'UMBAU_RENOVIERUNG', label: 'Umbau/Renovierung' },
  { value: 'AUSSENDIENST', label: 'Außendienst' },
  { value: 'HOTEL_ABTEILUNG_EVENT', label: 'Hotel-Abteilung Event' },
  { value: 'POSITIVES_FEEDBACK_FUER_HOTEL', label: 'positives Feedback für Hotel' },
  { value: 'HAUSFUEHRUNG', label: 'Hausführung' },
  { value: 'JAHRESGESPRAECH', label: 'Jahresgespräch' },
  { value: 'KOMMISSION', label: 'Kommission' },
  { value: 'KONKURS_INSOLVENZ', label: 'Konkurs/Insolvenz' },
  { value: 'KUENDIGUNG_KOOPERATION', label: 'Kündigung Kooperation' },
  { value: 'NEWSLETTER', label: 'Newsletter' },
  { value: 'OVERFLOW', label: 'Overflow' },
  { value: 'SPONSORING_HOTEL_ABTEILUNG_EVENT', label: 'Sponsoring Hotel Abteilung Event' },
  { value: 'KATALOG', label: 'Katalog' },
  { value: 'AKQUISE_PREMIUM', label: 'Akquise Premium' },
  { value: 'AKQUISE_PREMIUM_TERMIN_ERHALTEN', label: 'Akquise Premium – Termin erhalten' },
  { value: 'AKTION_SYMPOSION_HOTELS', label: 'Aktion Symposion Hotels' },
  { value: 'AKQUISE_PROJEKT', label: 'Akquise Projekt' },
  { value: 'BEDARF_GERING', label: 'Bedarf gering' },
  { value: 'BEDARF_HOCH', label: 'Bedarf hoch' },
  { value: 'BEDARF_MITTEL', label: 'Bedarf mittel' },
  { value: 'BEDARF_NEGATIV', label: 'Bedarf negativ' },
  { value: 'BEDARF', label: 'Bedarf' },
  { value: 'BESCHWERDE', label: 'Beschwerde' },
  { value: 'BLACKLIST_FUER_EINLADUNGEN', label: 'Blacklist für Einladungen' },
  { value: 'BLACKLIST_FUER_EINLADUNGEN_KOMMENTAR', label: 'Blacklist für Einladungen – Kommentar' },
  { value: 'BUCHUNGSENTSCHEIDENDER_GRUND', label: 'Buchungsentscheidender Grund' },
  { value: 'EINLADUNG_HM', label: 'Einladung HM' },
  { value: 'FEEDBACK_ANFRAGE_ERHALTEN', label: 'Feedback – Anfrage erhalten' },
  { value: 'GUTSCHEIN', label: 'Gutschein' },
  { value: 'KATALOG_SENDEN', label: 'Katalog senden' },
  { value: 'KONTAKT_INFO', label: 'Kontakt / Info' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_HOTEL_KOTHMUEHLE', label: 'Kundenrückgewinnung Symposion Hotel Kothmühle' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_SPORTHOTEL_WAGRAIN', label: 'Kundenrückgewinnung Symposion Sporthotel Wagrain' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_HOTEL_LANDLIEBE', label: 'Kundenrückgewinnung Symposion Hotel Landliebe' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_HOTEL_RAINERS', label: 'Kundenrückgewinnung Symposion Hotel Rainers' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_HOTEL_RAINERS21', label: 'Kundenrückgewinnung Symposion Hotel Rainers21' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_CITY_HOTEL_STOCKERAU', label: 'Kundenrückgewinnung Symposion City Hotel Stockerau' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_HOTEL_SCHWARZALM', label: 'Kundenrückgewinnung Symposion Hotel Schwarzalm' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_HOTEL_SCHACHNER', label: 'Kundenrückgewinnung Symposion Hotel Schachner' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_HOTEL_DAS_SCHLOSS_AN_DER_EISENSTRASSE', label: 'Kundenrückgewinnung Symposion Hotel Das Schloss an der Eisenstrasse' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_HOTEL_GROELLER_HOSPITALITY', label: 'Kundenrückgewinnung Symposion Hotel Gröller Hospitality' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_HOTEL_PICHLMAYRGUT', label: 'Kundenrückgewinnung Symposion Hotel Pichlmayrgut' },
  { value: 'KUNDENRUECKGEWINNUNG_SYMPOSION_HOTEL_ALTHOF_RETZ', label: 'Kundenrückgewinnung Symposion Hotel Althof Retz' },
  { value: 'MITBEWERB', label: 'Mitbewerb' },
  { value: 'NEUREGISTRIERUNG_DURCH_KUNDEN', label: 'Neuregistrierung durch Kunden' },
  { value: 'VORSTELLUNG_SEMINARGO', label: 'Vorstellung seminargo' },
  { value: 'TERMIN', label: 'Termin' },
  { value: 'POS', label: 'POS' },
  { value: 'POS_ANFRAGE_ERHALTEN', label: 'POS – Anfrage erhalten' },
  { value: 'STORNO', label: 'Storno' },
  { value: 'TEILNAHME_SEMINARGO_VERANSTALTUNG', label: 'Teilnahme seminargo Veranstaltung' },
  { value: 'TEILNAHME_HM_SYMPOSION_HOTEL_KOTHMUEHLE', label: 'Teilnahme HM Symposion Hotel Kothmühle' },
  { value: 'TEILNAHME_HM_SYMPOSION_SPORTHOTEL_WAGRAIN', label: 'Teilnahme HM Symposion Sporthotel Wagrain' },
  { value: 'TEILNAHME_HM_SYMPOSION_HOTEL_LANDLIEBE', label: 'Teilnahme HM Symposion Hotel Landliebe' },
  { value: 'TEILNAHME_HM_SYMPOSION_HOTEL_RAINERS', label: 'Teilnahme HM Symposion Hotel Rainers' },
  { value: 'TEILNAHME_HM_SYMPOSION_HOTEL_RAINERS21', label: 'Teilnahme HM Symposion Hotel Rainers21' },
  { value: 'TEILNAHME_HM_SYMPOSION_CITY_HOTEL_STOCKERAU', label: 'Teilnahme HM Symposion City Hotel Stockerau' },
  { value: 'TEILNAHME_HM_SYMPOSION_HOTEL_SCHWARZALM', label: 'Teilnahme HM Symposion Hotel Schwarzalm' },
  { value: 'TEILNAHME_HM_SYMPOSION_HOTEL_SCHACHNER', label: 'Teilnahme HM Symposion Hotel Schachner' },
  { value: 'TEILNAHME_HM_SYMPOSION_HOTEL_DAS_SCHLOSS_AN_DER_EISENSTRASSE', label: 'Teilnahme HM Symposion Hotel Das Schloss an der Eisenstrasse' },
  { value: 'TEILNAHME_HM_SYMPOSION_HOTEL_GROELLER_HOSPITALITY', label: 'Teilnahme HM Symposion Hotel Gröller Hospitality' },
  { value: 'TEILNAHME_HM_SYMPOSION_HOTEL_PICHLMAYRGUT', label: 'Teilnahme HM Symposion Hotel Pichlmayrgut' },
  { value: 'TEILNAHME_HM_SYMPOSION_HOTEL_ALTHOF_RETZ', label: 'Teilnahme HM Symposion Hotel Althof Retz' },
];

export const CONTACT_SUBJECT_LABELS = CONTACT_SUBJECTS.reduce<Record<string, string>>((acc, cur) => {
  acc[cur.value] = cur.label;
  return acc;
}, {});

/**
 * Gets display label for contact subject.
 * Handles both enum string values and object with name property.
 */
export const getContactSubjectLabel = (value?: string | null | { id: number; name: string }): string => {
  if (!value) return '';
  if (typeof value === 'object') {
    return value.name;
  }
  return CONTACT_SUBJECT_LABELS[value] || value;
};

